import React from "react";
import styles from "./UsersDetailsUplineTab.module.css";
import Card from "shared/Card";
import UplinesList from "./UplinesList";

const dreamUplineList = [
  {
    upline: "Diamond",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },
  {
    upline: "Emerald",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },
  {
    upline: "Platinum",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },

  {
    upline: "Diamond",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },
];

const wwgUplineList = [
  {
    upline: "Emerald",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },
  {
    upline: "Platinum",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },
  {
    upline: "Diamond",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },

  {
    upline: "Diamond",
    name: "Albus and Minerva McGongall",
    iboNum: "9636550",
    dsId: "[ID 15119862267554]",
  },
];

/**
 * Content in all details upline page.
 */

export function UsersDetailsUplineTab() {
  return (
    <>
      <div className={styles.container}>
        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>DREAMSTREAM UPLINE</h5>
            <div className={styles.hr} />
          </div>

          <div className={styles.usersDiv}>
            <UplinesList uplines={dreamUplineList} />
          </div>
        </Card>

        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>WWG UPLINE</h5>
            <div className={styles.hr} />
          </div>

          <div className={styles.usersDiv}>
            <UplinesList uplines={wwgUplineList} />
          </div>
        </Card>
      </div>
    </>
  );
}
